import { render } from "./maternity_postpartum.vue?vue&type=template&id=0a159a7b&scoped=true"
import script from "./maternity_postpartum.vue?vue&type=script&lang=js"
export * from "./maternity_postpartum.vue?vue&type=script&lang=js"

import "./maternity_postpartum.vue?vue&type=style&index=0&id=0a159a7b&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a159a7b"]])

export default __exports__